import { EditorState, SelectionState, Modifier } from "draft-js";

const replace = (editorState, blockKey, start, end, newWord) => {
  let contentState = editorState.getCurrentContent();

  const selection = SelectionState.createEmpty(blockKey).merge({
    anchorOffset: start,
    focusOffset: end,
  });

  contentState = Modifier.replaceText(contentState, selection, newWord);

  const nextFocus = selection.merge({
    anchorOffset: selection.getAnchorOffset() + newWord.length,
    focusOffset: selection.getAnchorOffset() + newWord.length,
  });

  return EditorState.forceSelection(
    EditorState.push(editorState, contentState),
    nextFocus
  );
};

export default replace;
